import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import SecondaryMenu from '../../menu/secondaryMenu.component';
import Select from '../../shared/reactSelect/select.component';
import PeriodDropdown from '../../shared/periodDropdown.component';
import { periodOrCurrentSelector, periodsSelector, connectionsOptionsSelector, environmentSuffixSelector } from '../../shared/store/selectors';
import { displayZeroSelector, hideDecimalsSelector, negativeMinusSelector } from '../../userData/store/selectors';
import {
  selectPeriodForDiagnostics,
  selectConnectionForDiagnostics,
  fetchInitialDataForDiagnosticsPage,
} from '../store/actions';
import { diagnosticsLoadingSelector, diagnosticsSelector } from '../store/selectors';
import DataGrid from './dataGrid.component';
import { DiagnosticsPropTypes } from './propTypes';
import downloadDiagnosticsXlsx from './downloadDiagnosticsXlsx';
import HamburgerDropdown from './hamburgerDropdown.component';

class ViewDiagnosticsPage extends PureComponent {
  static propTypes = {
    period: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    periods: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })).isRequired,
    connections: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })),
    connection: PropTypes.shape({
      connName: PropTypes.string,
    }),
    selectPeriodForDiagnostics: PropTypes.func.isRequired,
    selectConnectionForDiagnostics: PropTypes.func.isRequired,
    fetchInitialDataForDiagnosticsPage: PropTypes.func.isRequired,
    diagnostics: DiagnosticsPropTypes,
    diagnosticsLoading: PropTypes.bool.isRequired,

    shouldDisplayZero: PropTypes.bool.isRequired,
    hideDecimals: PropTypes.bool.isRequired,
    negativeMinus: PropTypes.bool.isRequired,
    environmentSuffix: PropTypes.string.isRequired,
  };

  componentDidMount = () => {
    this.props.fetchInitialDataForDiagnosticsPage();
  };

  selectPeriod = selectedPeriod => {
    const { periods } = this.props;

    const period = selectedPeriod
      ? periods.find(period => period.name === selectedPeriod.value)
      : null;

    this.props.selectPeriodForDiagnostics(period);
  };

  selectConnection = selectedConnection => {
    const value = selectedConnection ? selectedConnection.value : null;

    this.props.selectConnectionForDiagnostics(value);
  };

  downloadDiagnostics = callback => {
    const {
      diagnostics,
      period,
      connection,
      shouldDisplayZero,
      hideDecimals,
      negativeMinus,
      environmentSuffix,
    } = this.props;

    downloadDiagnosticsXlsx({
      diagnostics,
      periodName: period.name,
      connName: connection.connName,
      shouldDisplayZero,
      hideDecimals,
      negativeMinus,
      environmentSuffix,
    });
    callback();
  };

  render() {
    const {
      connection,
      connections,
      diagnostics,
      diagnosticsLoading,
    } = this.props;

    const selectedConnection = connection ? connection.connName : '';

    return (
      <div className="diagnostics-page">
        <SecondaryMenu>
          <PeriodDropdown
            onChange={this.selectPeriod}
          />
          <Select
            clearable={false}
            name="connection"
            options={connections}
            onChange={this.selectConnection}
            scrollMenuIntoView={false}
            value={selectedConnection}
            className="select-connection"
            virtualized
          />
          <div className="hamburger-dropdown ml-auto text-right">
            <HamburgerDropdown
              cannotDownloadDiagnostics={diagnosticsLoading}
              downloadDiagnostics={this.downloadDiagnostics}
            />
          </div>
        </SecondaryMenu>
        <div className="page">
          <div className="container-fluid">
            <div className="row no-gutters page-content-container">
              <div className="col">
                <div className="d-flex flex-row justify-content-between">
                  <h5>Diagnostics</h5>
                </div>
              </div>
            </div>
            <div className="row no-gutters page-content-container">
              <div className="col">
                <DataGrid
                  diagnostics={diagnostics}
                  diagnosticsLoading={diagnosticsLoading}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  period: periodOrCurrentSelector(state),
  periods: periodsSelector(state),
  connections: connectionsOptionsSelector(state),
  connection: state.shared.connection,
  diagnostics: diagnosticsSelector(state),
  diagnosticsLoading: diagnosticsLoadingSelector(state),
  shouldDisplayZero: displayZeroSelector(state),
  hideDecimals: hideDecimalsSelector(state),
  negativeMinus: negativeMinusSelector(state),
  environmentSuffix: environmentSuffixSelector(state),
});

export default connect(
  mapStateToProps,
  {
    selectPeriodForDiagnostics,
    selectConnectionForDiagnostics,
    fetchInitialDataForDiagnosticsPage,
  }
)(ViewDiagnosticsPage);
